import { render, staticRenderFns } from "./DashSingleValue.vue?vue&type=template&id=333e7d19"
import script from "./DashSingleValue.vue?vue&type=script&lang=js"
export * from "./DashSingleValue.vue?vue&type=script&lang=js"
import style0 from "./DashSingleValue.vue?vue&type=style&index=0&id=333e7d19&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports